import styled from 'styled-components';
import {basicColor, device, font} from '@/styles/template';

export const RightWrap = styled.div`
`;

export const RightAnswerTooltip = styled.div`
    width: 100%;
    display: block;
    position: relative;
    margin-bottom: 6rem;
`;

export const LabelText = styled.span`
    user-select: none;
    ${font.basic};

    color: ${basicColor.white};
    
    ${({ isCorrect }) => isCorrect === false && `
        text-decoration: line-through;
        &.active {color: ${basicColor.red};}
    `}
    
    ${({ isCorrect }) => isCorrect === true && `
        color: ${basicColor.secondary};
    `}
    
    @media ${device.tablet} {
        ${font.basicBig};
    }
`;